import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";

export class StandingsAssetsRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + '/Standings';
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }

}